import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NotificationBlock from '@helper/NotificationBlock';
/**
 * @export
 * Why a value failed the field's check: a compact red block, the problem in
 * bold and the hint under it.
 */
const MediaCheckNotice = ({ message, action }) => {
    const [problem, ...rest] = (message || '').split('\n');
    const hint = rest.join(' ').trim();
    // The box is a size container: in a narrow panel the button goes under the text
    return _jsx("div", { className: "uxpcore_mediapicker__notice-box", children: _jsx(NotificationBlock, { class: "uxpcore_mediapicker__notice", variant: "danger", mode: "compact", layout: "bordered", icon: true, action: action, children: _jsxs("div", { className: "uxpcore_mediapicker__check", children: [_jsx("strong", { className: "uxpcore_mediapicker__check-problem", children: problem }), hint && _jsx("span", { className: "uxpcore_mediapicker__check-hint", children: hint })] }) }) });
};
export default MediaCheckNotice;
